import { AppButton } from "@/shared/Components";
import { PlusIcon } from "@/shared/icons";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  onClick: () => void;
};

export const AddNoteButton: FC<Props> = ({ onClick }) => {
  return (
    <AppButton onClick={onClick} type="primary" className={styles.float}>
      <PlusIcon className={styles.icon} />
    </AppButton>
  );
};
